import { Controller } from '@hotwired/stimulus';
import { showNotification } from '@components/notification_box/component_controller';

export default class extends Controller {
  static values = {
    successMessage: { type: String, default: '' },
  };

  connect() {
    this.element.addEventListener(
      'ajax:success',
      this.handleSuccess.bind(this)
    );
  }

  handleSuccess(event) {
    document.body.dispatchEvent(
      new CustomEvent('iframe-preview:reload', { bubbles: true })
    );

    const [newDocumentOrEmptyString] = event.detail;

    if (newDocumentOrEmptyString !== '') {
      this.element.outerHTML =
        newDocumentOrEmptyString.documentElement.innerHTML;
    }

    if (this.successMessageValue.length > 0) {
      showNotification(this.successMessageValue);
    }
  }
}
